const disabledFlag = String(process.env.REACT_APP_DISABLE_PAYMENTS || '').trim().toLowerCase();

/**
 * Staging/free-launch kill switch for real-money payment initiation.
 * Existing production behaviour is unchanged unless a frontend build
 * explicitly sets REACT_APP_DISABLE_PAYMENTS=true.
 */
export const PAYMENTS_DISABLED = disabledFlag === 'true';

export const PAYMENTS_UNAVAILABLE_MESSAGE =
  'Payments are unavailable in this staging/free-launch preview. No real-money transaction was started.';

const INITIATION_ROUTES = [
  /^\/api\/payments\/(?:coin-packs|book|subscription|vault)\/checkout\/?$/,
  /^\/api\/payments\/stripe\/payment-intent\/?$/,
  /^\/api\/payments\/subscription\/bank-transfer\/?$/,
  /^\/api\/subscription\/(?:initialize|paystack\/initialize|paypal\/create-order)\/?$/,
  /^\/api\/vault\/buy\/(?:paypal\/create-order|bank-transfer)\/?$/,
];

const requestPath = (url) => {
  try {
    const base = typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : 'http://localhost';
    return new URL(String(url), base).pathname;
  } catch {
    return '';
  }
};

/** True only for application requests that can start a real-money flow. */
export const isPaymentInitiationRequest = (url, options = {}) => {
  const method = String(options.method || 'GET').toUpperCase();
  if (method !== 'POST') return false;
  const pathname = requestPath(url);
  return INITIATION_ROUTES.some((pattern) => pattern.test(pathname));
};

/**
 * Return an HTTP-like response so existing callers take their normal non-2xx
 * path while no request reaches the backend.
 */
export const paymentsUnavailableResponse = () => new Response(
  JSON.stringify({
    detail: PAYMENTS_UNAVAILABLE_MESSAGE,
    code: 'payments_disabled',
  }),
  {
    status: 503,
    headers: { 'Content-Type': 'application/json' },
  },
);
